import { render, staticRenderFns } from "./PraticheTable.vue?vue&type=template&id=96f8798a&scoped=true&"
import script from "./PraticheTable.vue?vue&type=script&lang=js&"
export * from "./PraticheTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f8798a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96f8798a')) {
      api.createRecord('96f8798a', component.options)
    } else {
      api.reload('96f8798a', component.options)
    }
    module.hot.accept("./PraticheTable.vue?vue&type=template&id=96f8798a&scoped=true&", function () {
      api.rerender('96f8798a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShipmentsPage/PraticheTable.vue"
export default component.exports